import TabBar from '../../../component/tab-bar/tab-bar';
import React, { useState } from 'react';
import DocsSettingsPage from './tabs/document-types/docs.settings.page';
import { UserDefaultCreationDocuments } from './tabs/user-default-creation-documents/user-default-creation-documents';

const tabs = ['סוגי מסמכים', 'יצירת מסמכים למשתמש'];

const components = [<DocsSettingsPage />, <UserDefaultCreationDocuments />];

export const DocsGeneral = () => {
  const [index, setIndex] = useState(0);
  const onTabSelected = (index: number) => {
    setIndex(index);
  };

  return (
    <div style={{ marginTop: '16px' }}>
      <div className={'studies-settings-title'}>הגדרות מערכת</div>

      <TabBar
        tabs={tabs}
        onClick={(index) => {
          onTabSelected(index);
          console.log('The index ' + index + 'Is clicked');
        }}
      ></TabBar>

      {components[index]}
    </div>
  );
};
